import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "../../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { getData, setData } from "../../../utils/util";
import { updateAdminProfile, uploadAdminProfile } from "../../../actions/admin_action";
// import {uploadAminProfile} from "../../../actions/admin_action"
// core components

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import Card from "../../../components/Card/Card.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CardAvatar from "../../../components/Card/CardAvatar.jsx";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../../utils/util.js";

toastr.options = {
  closeButton: true,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const userDetails = {
  name: "Admin",
  email: "admin@gmail.com",
  profileImage:
    "http://www.ala-access.com/s/wp-content/uploads/2016/01/analyst-placeholder-avatar.png",
};

class UpdateProfile extends Component {
  constructor(props) {
    super(props);
    let BerPay_Admin = getData("BerPay_Admin");
    
    this.state = {
      BerPay_Admin: BerPay_Admin,
      profile_pic:BerPay_Admin && BerPay_Admin.profile_pic
    };
  }
 

  updateAdminProfile = () => {
    const { BerPay_Admin ,profile_pic} = this.state;
    if (!BerPay_Admin.name) {
      toastr.error("Please enter Correct details");
    } else {
      let obj = {
        _id: BerPay_Admin._id,
        name: BerPay_Admin.name,
        profile_pic:profile_pic
      };
      this.props.updateAdminProfile(obj, () => {
        let admin = getData("BerPay_Admin");
        admin["name"] = BerPay_Admin.name;
        admin["profile_pic"]=profile_pic
        setData("BerPay_Admin", admin);
        this.props.handleClose();
      });
    }
  };

  handleChange=({target})=>{
    const fd = new FormData();
    fd.append("file", target.files[0]);
    console.log("00000000",fd,target.files[0])
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` , "Content-Type": "multipart/form-data",},
        
      };
    }
    axios
        .post(`${domain}/user/upload/profile/avatar`, fd, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
              toastr.success("Profile Picture Uploaded Successfully!")
              // setTimeout(()=>{
              //     window.location.reload();
              // }, 2000)
              this.setState({
                profile_pic:res.data.data.profile_pic_url
              })
          }
        })
  }

  render() {
    const { show, handleClose, openResetPassword } = this.props;
    const { BerPay_Admin } = this.state;
    return (
      <div>
        <Dialog
          className="update-profile-dialog-box"
          open={show}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}
          keepMounted
          PaperProps={{
            style: {
              display: "inline-table",
              position: "relative",
              width: "35%",
            },
          }}
        >
          <Card profile style={{ display: "inline" }}>
            <CardAvatar profile>
             
                <img src={ this.state.profile_pic ? this.state.profile_pic : (BerPay_Admin && BerPay_Admin.profile_pic? BerPay_Admin.profile_pic : userDetails.profileImage)} alt="..."  onClick={(e) => {
                    e.stopPropagation();
                    this.inputRef.click()} }
                    className="profilepic"
                    />
            {/* <input type="file" onChange={(e)=>this.uploadAminProfileS(e)} name="image" id="image" accept="image/*" /> */}
            <input ref={(inputRef)=>{
                  this.inputRef=inputRef
                }}  type="file" accept="image/*" style={{display:"none"}} onChange={this.handleChange} />
              
            </CardAvatar>
            <CardBody profile>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Name"
                  type="name"
                  fullWidth
                  value={BerPay_Admin.name}
                  onChange={(e) => {
                    BerPay_Admin["name"] = e.target.value;
                    this.setState(
                      {
                        BerPay_Admin,
                      },
                      () => console.log(BerPay_Admin)
                    );
                  }}
                />
                <TextField
                  margin="dense"
                  id="email"
                  label="Email"
                  type="email"
                  fullWidth
                  disabled={true}
                  value={BerPay_Admin.email}
                />
              </DialogContent>
            </CardBody>
          </Card>
          <DialogActions style={{ textAlign: "center", display: "block" }}>
            <Button color="primary" onClick={handleClose} className="canbutton">
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="updatebtn"
              onClick={this.updateAdminProfile}
            >
              Update
            </Button>
          </DialogActions>
          <div className={"reset-password"}>
            <a onClick={openResetPassword} style={{cursor:"pointer"}}>Reset Password</a>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // loginError: state.admin.loginError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAdminProfile: (obj, callback) =>
      dispatch(updateAdminProfile(obj, callback)),
    uploadAdminProfile: (obj)=>dispatch(uploadAdminProfile(obj))
  };
};

const UpdateProfileComponent = withStyles(extendedTablesStyle)(UpdateProfile);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateProfileComponent);
